import { MessageCircle, Truck } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink, WA } from "../config/site";

export const DeliveryPromo = () => (
  <section id="delivery" className="bg-gold text-charcoal relative overflow-hidden">
    <Truck
      className="absolute -right-10 -bottom-14 w-72 h-72 text-charcoal/[0.07] rotate-[-8deg]"
      aria-hidden="true"
    />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 relative">
      <div className="max-w-3xl">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-charcoal/60">
            Free Home Delivery
          </p>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-balance leading-[1.05]">
            Too Busy to Visit? <span className="italic font-medium">We Deliver.</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-charcoal/70 leading-relaxed max-w-xl">
            Enjoy <strong>FREE delivery within a 5 km radius</strong> on orders
            above <strong>₹1,500</strong>. Send us your list on WhatsApp and
            we'll take it from there.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="mt-9 flex flex-wrap items-center gap-5">
            <a
              href={waLink(WA.delivery)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="delivery-whatsapp-cta"
              className="inline-flex items-center gap-2.5 bg-charcoal text-cream font-semibold rounded-full px-8 py-4 hover:bg-black transition-all duration-300 hover:-translate-y-0.5 shadow-[0_16px_40px_-12px_rgba(18,18,18,0.5)]"
            >
              <MessageCircle size={18} />
              Order on WhatsApp
            </a>
            <span className="font-mono text-xs sm:text-sm tracking-[0.15em] uppercase text-charcoal/60">
              Within 5 km · Above ₹1,500
            </span>
          </div>
          <p className="mt-6 text-xs sm:text-sm text-charcoal/55">
            Delivery availability and order details can be confirmed through
            WhatsApp.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
